export default __webpack_public_path__ + "static/media/footerLogo.2388ade1.png";